import { render, staticRenderFns } from "./news8.vue?vue&type=template&id=e575ff42&scoped=true"
import script from "./news8.vue?vue&type=script&lang=js"
export * from "./news8.vue?vue&type=script&lang=js"
import style0 from "./news8.vue?vue&type=style&index=0&id=e575ff42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e575ff42",
  null
  
)

export default component.exports